import React from 'react';

import blush from '../assets/swatches/blush.png';
import brushstroke from '../assets/swatches/brushstroke.png';
import chamomile from '../assets/swatches/chamomile.png';
import confetti from '../assets/swatches/confetti.png';
import aloe from '../assets/swatches/aloe.png';
import amethyst from '../assets/swatches/amethyst.png';
import clay from '../assets/swatches/clay.png';
import lattice from '../assets/swatches/lattice.png';
import offleash from '../assets/swatches/off-leash.png';
import sahara from '../assets/swatches/sahara.png';
import decodot from '../assets/swatches/decodot.png';
import ink from '../assets/swatches/ink.png';
import lagoon from '../assets/swatches/lagoon.png';
import mist from '../assets/swatches/mist.png';
import monstera from '../assets/swatches/monstera.png';
import persimmon from '../assets/swatches/persimmon.png';
import script from '../assets/swatches/script.png';
import seasalt from '../assets/swatches/sea-salt.png';
import soldout from '../assets/swatches/soldout.png';
import blushstripe from '../assets/swatches/blush-colorblock.png';
import miststripe from '../assets/swatches/mist-colorblock.png';
import plumstripe from '../assets/swatches/plum-colorblock.png';
import confettipompom from '../assets/swatches/confetti-pom-pom.png';
import fuzzymist from '../assets/swatches/fuzzy-mist.png';
import positivitybrush from '../assets/swatches/positivity-brush.png';
import seaglassleash from '../assets/swatches/sea-glass-leash.png';
import sunterrazzo from '../assets/swatches/sun-terrazzo.png';
import wildcatsdots from '../assets/swatches/wildcats-dots.png';
import squiggle from '../assets/swatches/squiggle.png';
import wwftoucans from '../assets/swatches/wwf-toucans.png';
import wwfhighseas from '../assets/swatches/wwf-high-seas.png';
import wwfwildcats from '../assets/swatches/wwf-wildcats.png';
import wwfwildflowers from '../assets/swatches/wwf-wildflowers.png';
import pwinthegarden from '../assets/swatches/pw-in-the-garden.png';
import pwcrawlers from '../assets/swatches/pw-crawlers.png';
import pwdancingdaisies from '../assets/swatches/pw-dancing-daisies.png';
import pwdaisygarden from '../assets/swatches/pw-daisy-garden.png';
import rndragonfruit from '../assets/swatches/rn-dragonfruit.png';
import rnreef from '../assets/swatches/rn-reef.png';
import ojcosmos from '../assets/swatches/oj-cosmos.png';
import ajjfruits from '../assets/swatches/ajj-fruits.png';
import ajjtreats from '../assets/swatches/ajj-treats.png';
import barley from '../assets/swatches/barley.png';
import dove from '../assets/swatches/dove.png';
import plum from '../assets/swatches/plum.png';
import seaglass from '../assets/swatches/sea-glass.png';
import sunshower from '../assets/swatches/sunshower.png';
import terrazzo from '../assets/swatches/terrazzo.png';
import pompomparty from '../assets/swatches/pom-pom-party.png';
import positivityparade from '../assets/swatches/positivity-parade.png';
import fuzzyfriends from '../assets/swatches/fuzzy-friends.png';
import dappledot from '../assets/swatches/dapple-dot.png';
import mcmagicgarden from '../assets/swatches/mc-magic-garden.png';
import mcfoxes from '../assets/swatches/mc-foxes.png';
import mccranes from '../assets/swatches/mc-cranes.png';
import ReactPlayer from 'react-player';
import Flickity from 'react-flickity-component';
import jQuery from "jquery";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';


const flickityOptions = {
    initialIndex: 0
}

var hasRun = "";
let newObj = {};
var tapAreaGallery;

function add(a, b) {
    return a + b;
}

function obj(){
    obj=new Object();
    this.add=function(key,value){
        obj[""+key+""]=value;
    }
    this.obj=obj
}

function isEmpty(obj) {
    for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
            return false;
    }

    return JSON.stringify(obj) === JSON.stringify({});
}

function formatMoney(n, c, d, t) {
  var c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;

  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

function priceCalulator(array, productid){
	let total = 0.00
	let cartArray = array
	let totalprice = 0.00
	cartArray.map((product, i) =>
		{

			if(product.productID === productid){
				if(product.cartObjects.length > 0){
					product.cartObjects.map((obj, i) =>
					total += obj.price/100 * obj.quanitity
					);
				}
				totalprice = formatMoney(total)

			}
		}
	);
	return totalprice
}

function evaluateIfSoldOut(quantity){
	if(quantity <= 0){
		return 'sold-out'
	}else{
		return ''
	}
}

function evaluateIfSoldOutReturnQ (product, q) {
	let finalCount = 0;
	if(product.title.includes("Wipe Up Wash") || product.title.includes("Washing Powder")){
		finalCount = product.variants[0].inventory_quantity
	}else{
		product.variants.map((variant,i) => {
			if(variant.inventory_quantity > 0){
				finalCount += variant.inventory_quantity
			}
		});
	}
	if(finalCount <= 0){
		return 0
	}else{
		return q
	}
}

function fireClick(node){
    if (document.createEvent) {
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        node.dispatchEvent(evt);
    } else if (document.createEventObject) {
        node.fireEvent('onclick') ;
    } else if (typeof node.onclick == 'function') {
        node.onclick();
    }
}

function priceObjectCalulator(obj){
	let total = 0.00
	let cartObj = obj
	if(cartObj.cartObject.length > 1){
		cartObj.cartObject.map((obj, i) =>
			total += obj.price * obj.quanitity
		);
	}
	let totalprice = formatMoney(total/100)
	return totalprice

}
function simplePriceCalc(quant, price){
	let total = formatMoney(quant * (price))

	return total
}

class ProductOverlay extends React.Component {

	constructor(props){
	    // Pass props to parent class
	    super(props);
	    // Set initial state
	    this.state = {
	      videoOverlay: false,
	      videoOverlayURL: '',
	      productQuantity: 0,
	      description: '',
	      price: '',
	      panel: 0,
	      backgroundImage: '',
	      minicart: {},
	      cart: [],
	      instructionsOverlay: false,
	      instructions: '',
	      size: '',
	      title: '',
	      totalprice: "TOTAL: $ " + 0.00,
	      product: {
	      	'variants': [
	      		{
	      			"options": [""]
	      		}
	      	],
	      	'meta': []

	      },
	      galleryImages: [],
	      imageVariants: [],
	      productVariants: []
	    }

 		this.closeOverlayAndSave 	= this.closeOverlayAndSave.bind(this);
 		this.renderDescription		= this.renderDescription.bind(this);
 		this.renderPrints			= this.renderPrints.bind(this);
 		this.renderNewInstructions	= this.renderNewInstructions.bind(this);
 		this.renderBackgroundImage  = this.renderBackgroundImage.bind(this);
 		this.updateMiniCart			= this.updateMiniCart.bind(this);
 		this.evaluateIfTooMany		= this.evaluateIfTooMany.bind(this);
 		this.reduceQuantity			= this.reduceQuantity.bind(this);
 		this.renderInput			= this.renderInput.bind(this);
 		this.getDefaultInputValue	= this.getDefaultInputValue.bind(this);
 		this.increment 				= this.increment.bind(this);
 		this.decrement 				= this.decrement.bind(this);
 		this.setActivePrints		= this.setActivePrints.bind(this);
 		this.showVariantFeaturedImages = this.showVariantFeaturedImages.bind(this);
 		this.showThisProductSpecificImage = this.showThisProductSpecificImage.bind(this);
 		this.showThisProductSpecificImageGallery = this.showThisProductSpecificImageGallery.bind(this);
 		this.evaluateIfActive = this.evaluateIfActive.bind(this);
 		this.openVideoOverlay = this.openVideoOverlay.bind(this);
 		this.openInstructionsOverlay = this.openInstructionsOverlay.bind(this);
 		this.closeVideoOverlay = this.closeVideoOverlay.bind(this);
 		this.closeInstructionsOverlay = this.closeInstructionsOverlay.bind(this);
 		this.renderVideoIframe = this.renderVideoIframe.bind(this);
 		this.updateQuantityWhole = this.updateQuantityWhole.bind(this);
 		this.reduceQuantityAccessibility = this.reduceQuantityAccessibility.bind(this);
 		this.evaluateVariantAccessibility = this.evaluateVariantAccessibility.bind(this);
 		this.updateQuantityAccessibility = this.updateQuantityAccessibility.bind(this);
 		this.showVariantFeaturedImagesAccessibility = this.showVariantFeaturedImagesAccessibility.bind(this);
 		this.evaluateIfTooManyAccessibility = this.evaluateIfTooManyAccessibility.bind(this);
 		this.closeInstructionsOverlayAccessibility = this.closeInstructionsOverlayAccessibility.bind(this);
 		this.closeVideoOverlayAccessibility = this.closeVideoOverlayAccessibility.bind(this);
 		this.openInstructionsOverlayAccessibility = this.openInstructionsOverlayAccessibility.bind(this);
 		this.openVideoOverlayAccessibility = this.openVideoOverlayAccessibility.bind(this);
 		this.showThisProductSpecificImageGalleryAccessibility = this.showThisProductSpecificImageGalleryAccessibility.bind(this);
 		this.showThisProductSpecificImageAccessibility = this.showThisProductSpecificImageAccessibility.bind(this);
 		this.closeOverlayAndSaveAccessibility = this.closeOverlayAndSaveAccessibility.bind(this);
 		this.ifReadyToSaveGoAheadAndSaveAndClose = this.ifReadyToSaveGoAheadAndSaveAndClose.bind(this);
 		this.ifReadyToSaveGoAheadAndSaveAndCloseAccessibility = this.ifReadyToSaveGoAheadAndSaveAndCloseAccessibility.bind(this);
 		this.printTotalsMessage = this.printTotalsMessage.bind(this);
 		this.printTotalsMessageAction = this.printTotalsMessageAction.bind(this);
 		this.getSlugHandle = this.getSlugHandle.bind(this);
	}


	getSlugHandle(handle){
		let imageslug = handle.replace(/\s+/g, '').toLowerCase();
		return imageslug
	}

	evaluateIfActive(i){
		if(i == 0){
			return 'active'
		}else{
			return '';
		}
	}

	ifReadyToSaveGoAheadAndSaveAndCloseAccessibility(e){
		if(this.state.readyToSave){
			if(e.which == 13 || e.keyCode == 13) {
				this.closeOverlayAndSave(e);
			}
		}
	}

	closeOverlayAndSaveAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.closeOverlayAndSave(e);
		}
	}

	closeVideoOverlayAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.closeVideoOverlay(e);
		}
	}

	closeInstructionsOverlayAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.closeInstructionsOverlay(e);
		}
	}

	reduceQuantityAccessibility(swatch, e){
		if(e.which == 13 || e.keyCode == 13) {
			this.reduceQuantity(swatch);
		}
	}

	evaluateVariantAccessibility(a,b,e){
		if(e.which == 13 || e.keyCode == 13) {
			this.evaluateVariant(a,b,e)
		}
	}

	updateQuantityAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.updateQuantity(e);
		}
	}

	showThisProductSpecificImageAccessibility(e,a,b){
		if(e.which == 13 || e.keyCode == 13) {
			this.showThisProductSpecificImage(e,a,b);
		}
	}

	showThisProductSpecificImageGalleryAccessibility(e, a){
		if(e.which == 13 || e.keyCode == 13) {
			this.showThisProductSpecificImageGallery(e,a)
		}
	}

	showVariantFeaturedImagesAccessibility(a, b, e){
		if(e.which == 13 || e.keyCode == 13) {
			this.showVariantFeaturedImages(a, b);
		}
	}

	evaluateIfTooManyAccessibility(a,b, e){
		if(e.which == 13 || e.keyCode == 13) {
			this.evaluateIfTooMany(a,b)
		}
	}

	decrementAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.decrement(e);
		}
	}

	incrementAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.increment(e);
		}
	}

	openInstructionsOverlayAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.openInstructionsOverlay(e);
		}
	}

	openVideoOverlayAccessibility(e, link){
		if(e.which == 13 || e.keyCode == 13) {
			this.openVideoOverlay(e, link);
		}
	}


	evaluateVariant(handle, inventory){

		let maxQuantity = this.state.productQuantity
		var elementToUpdateIfAllowed = document.getElementById(handle)
		let elementValue = Number(elementToUpdateIfAllowed.value)
		let elementVariantID = elementToUpdateIfAllowed.getAttribute("data-variant");
		let lastValue = elementToUpdateIfAllowed.getAttribute("data-last-value");
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		let combinedValuesArray = [];

		for (let item of allInputValues) {
			combinedValuesArray.push(Number(item.value));
		}

		let combinedValues = combinedValuesArray.reduce(add, 0);

		if(maxQuantity >= combinedValues && elementValue <= inventory){
			elementToUpdateIfAllowed.value = elementValue
			elementToUpdateIfAllowed.text = elementValue
			this.updateMiniCart(elementValue, elementVariantID);
		}else{
			elementToUpdateIfAllowed.value = lastValue
			elementToUpdateIfAllowed.text = lastValue
			this.updateMiniCart(lastValue, elementVariantID);
		}


	}

	printTotalsMessage(qty, maxQ, product, price, cart){
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		var totalInputCount = 0;

		var productId = product.id

		var newCart = cart.filter(x => x.productID == productId);


		if(newCart[0].hasOwnProperty("cartObjects") && newCart[0].cartObjects.length > 1){
			newCart[0].cartObjects.map((obj, i) =>
				totalInputCount += obj.quanitity
			);
		}

		if(product.options.includes("Color")){
			if(qty < totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "REMOVE PRINTS BELOW TO CONTINUE";
			}else if(qty > totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "SELECT PRINTS BELOW TO CONTINUE";
			}else{
				this.setState({
					readyToSave: true
				});
				return "TOTAL: $" + simplePriceCalc(qty, price/100);
			}
		}else{
			this.setState({
				readyToSave: true
			});
			return "TOTAL: $" + simplePriceCalc(qty, price/100);
		}
	}

	getTotalFromObjectPrice(obj, qty, product){
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		var totalInputCount = 0;
		for (let item of allInputValues) {
			let quant = (Number(item.value));
			let elementVariantID = item.getAttribute("data-variant");
			let price = item.getAttribute("data-variant-price");
			totalInputCount = totalInputCount + quant;
		}
		if(product.options.includes("Color")){
			if(qty < totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "REMOVE PRINTS BELOW TO CONTINUE";
			}else if(qty > totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "SELECT PRINTS BELOW TO CONTINUE";
			}else{
				this.setState({
					readyToSave: true
				});
				return "TOTAL: $" + priceObjectCalulator(obj);
			}
		}else{
			this.setState({
				readyToSave: true
			});
			return "TOTAL: $" + priceObjectCalulator(obj);
		}

	}

	printTotalsMessageAction(qty, price, product, maxQ){
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		var totalInputCount = 0;
		for (let item of allInputValues) {
			let quant = (Number(item.value));
			let elementVariantID = item.getAttribute("data-variant");
			let price = item.getAttribute("data-variant-price");
			totalInputCount = totalInputCount + quant;
		}
		if(product.options.includes("Color")){
			if(qty < totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "REMOVE PRINTS BELOW TO CONTINUE";
			}else if(qty > totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "SELECT PRINTS BELOW TO CONTINUE";
			}else{
				this.setState({
					readyToSave: true
				});
				return "TOTAL: $" + simplePriceCalc(qty, price);
			}
		}else{
			this.setState({
				readyToSave: true
			});
			return "TOTAL: $" + simplePriceCalc(qty, price);
		}
	}

	updateQuantityWhole(e){
		if(this.state.product.options.includes("Color")){
			if( e.target.value > this.state.maxQuantity){
				this.setState({
					productQuantity: this.state.maxQuantity,
					minicart: [{
		                'productID': this.state.product.id,
		                'cartObject': []
		            }],
		            totalprice: this.printTotalsMessageAction(this.state.maxQuantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}else{
				this.setState({
					productQuantity: parseInt(e.target.value),
					minicart: [{
		                'productID': this.state.product.id,
		                'cartObject': []
		            }],
		            totalprice: this.printTotalsMessageAction(parseInt(e.target.value), this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}
		}else{
			if( e.target.value > this.state.maxQuantity){
				this.setState({
					productQuantity: this.state.maxQuantity,
					minicart: [{
		                'productID': this.state.product.id,
		                'cartObject': []
		            }],
					totalprice: this.printTotalsMessageAction(this.state.maxQuantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}else{
				this.setState({
					productQuantity: parseInt(e.target.value),
					minicart: [{
		                'productID': this.state.product.id,
		                'cartObject': []
		            }],
					totalprice: this.printTotalsMessageAction(parseInt(e.target.value), this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)
				});
			}
		}
	}

	ifReadyToSaveGoAheadAndSaveAndClose(e){
		if(this.state.readyToSave){
			this.closeOverlayAndSave(e);
		}
	}

	updateQuantity(e){
		var quantity = e.target.value;
		var productId = this.state.product.id
		if( this.state.maxQuantity > this.state.productQuantity){
			this.setState({
				productQuantity: quantity,
				minicart: [{
	                'productID': productId,
	                'cartObject': []
	            }],
				totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

			});
		}else{

		}

	}

	increment(){
		var productId = this.state.product.id
		if(this.state.product.options.includes("Color")){
			if( this.state.maxQuantity > this.state.productQuantity) {
				var quantity = this.state.productQuantity + 1
				this.setState({
					productQuantity: quantity,
					minicart: {
						'productID': productId,
						'cartObject': []
					},
					totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}
		}else{
			if( this.state.maxQuantity > this.state.productQuantity){
				var quantity = this.state.productQuantity + 1
				this.setState({
					productQuantity: quantity,
					minicart: {
						'productID': productId,
						'cartObject': []
					},
					totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)
				});
			}else{
				var quantity = this.state.productQuantity
				this.setState({
					productQuantity: quantity,
					minicart: {
						'productID': productId,
						'cartObject': []
					},
					totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)
				});
			}
		}
	
	}

	decrement(){

		var productId = this.state.product.id
		var quantity = this.state.productQuantity - 1
		if(this.state.product.options.includes("Color")){
			if(this.state.productQuantity - 1 >= 0){
				this.setState({
					productQuantity: quantity,
					minicart: [{
		                'productID': productId,
		                'cartObject': []
		            }],
		            totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

	        	});
			}
		}else{
			if(this.state.productQuantity - 1 >= 0){
				this.setState({
					productQuantity: quantity,
					minicart: [{
		                'productID': productId,
		                'cartObject': []
		            }],
					totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}
		}

	
	}

	getDefaultInputValue(variantId){

		if(this.state.cart.length > 0){
			this.state.cart.map((product, i) =>
				{
					if( this.state.product.id == product.productID && product.cartObjects.length > 0){
						product.cartObjects.map((variant, i) =>
							{
								if (variantId == variant.id){
									return variant.quantity
								}
							}
						);
					}else if(this.state.product.id == product.productID){
						var num = 0
						return num
					}else{
						return false
					}

				}
			);
		}
	}

	setActivePrints(x){
		var allVariantThumbnails = document.getElementsByClassName("product-variant-thumbnails");
		for(var i = 0; i < allVariantThumbnails.length; i++){
		   allVariantThumbnails[i].classList.add("hidden")
		}
		let activeVariantThumbnails = document.getElementById("productVariant" + String(x))
		activeVariantThumbnails.classList.remove("hidden");

	}

	showVariantFeaturedImages(x, y){

		//Set New Thumbnails
		var allVariantThumbnails = document.getElementsByClassName("product-variant-thumbnails");
		for(var i = 0; i < allVariantThumbnails.length; i++){
		   allVariantThumbnails[i].classList.add("hidden")
		}
		let activeVariantThumbnails = document.getElementById("productVariant" + String(x))
		activeVariantThumbnails.classList.remove("hidden");
		fireClick(activeVariantThumbnails.firstChild.firstChild)
		activeVariantThumbnails.firstChild.classList.add('active')

		//Set Active Swatch
		var allSwatches = document.getElementsByClassName("variant-swatch");
		for(var i = 0; i < allSwatches.length; i++){
		   allSwatches[i].classList.remove("active")
		}
		let activeSwatch = document.getElementById(y)
		activeSwatch.classList.add("active");
		var thbnailcount = jQuery('.product__thumbnail:visible').length;
		jQuery('.product__thumbnail .product__thumbnail-inner').each(function(){
			jQuery(this).removeAttr('aria-label');
		})
		jQuery('.product__thumbnail:visible .product__thumbnail-inner').each(function(i){
			jQuery(this).attr('aria-label', "image " + (i + 1) + " of " + thbnailcount)
		})
	}


	renderInput(swatchId, variantId){
		return(
			<input type="number"
                   id={swatchId}
                   data-variant={variantId}
                   className="quantity swatch-quantity"
                   onChange={this.updateQuantity}>
            </input>
		);
	}

	reduceQuantity(handle){
		var elementToUpdateIfAllowed = document.getElementById(handle)
		let elementValue = Number(elementToUpdateIfAllowed.value)
		let elementVariantID = elementToUpdateIfAllowed.getAttribute("data-variant");

		if(elementValue > 0){
			elementToUpdateIfAllowed.setAttribute('data-last-value',elementValue - 1)
			elementToUpdateIfAllowed.value = elementValue - 1
			elementToUpdateIfAllowed.text = elementValue - 1
			this.updateMiniCart(elementValue - 1, elementVariantID);
		}else{
			elementToUpdateIfAllowed.setAttribute('data-last-value',elementValue)
		}

	}

	evaluateIfTooMany(handle, inventory){

		let maxQuantity = this.state.productQuantity
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		var elementToUpdateIfAllowed = document.getElementById(handle);
		let elementValue = Number(elementToUpdateIfAllowed.value)
		let elementVariantID = elementToUpdateIfAllowed.getAttribute("data-variant");

		let combinedValuesArray = [];

		for (let item of allInputValues) {
			combinedValuesArray.push(Number(item.value));
		}

		let combinedValues = combinedValuesArray.reduce(add, 0);

		if(maxQuantity > combinedValues && elementValue < inventory){
			elementToUpdateIfAllowed.setAttribute('data-last-value',elementValue + 1)
			elementToUpdateIfAllowed.value = elementValue + 1
			elementToUpdateIfAllowed.text = elementValue + 1
			this.updateMiniCart(elementValue + 1, elementVariantID);
		}else{
			elementToUpdateIfAllowed.setAttribute('data-last-value',elementValue)
		}

	}

	renderSwatchImage(handleOne){
		let swatchImagePath = "";
		let imageslug = handleOne.replace(/\s+/g, '').toLowerCase();
		let image = '';
		if(imageslug === 'blush'){
			image = <img src={blush} alt="blush" className="swatch-image" />
		}else if (imageslug == 'brushstroke'){
			image = <img src={brushstroke} alt="brushstroke" className="swatch-image"/>
		}else if (imageslug == 'chamomile'){
			image = <img src={chamomile} alt="chamomile" className="swatch-image"/>
		}else if (imageslug == 'pwinthegarden'){
			image = <img src={pwinthegarden} alt="PW In The Garden" className="swatch-image"/>
		}else if (imageslug == 'pwcrawlers'){
			image = <img src={pwcrawlers} alt="PW Crawlers" className="swatch-image"/>
		}else if (imageslug == 'pwdancingdaisies'){
			image = <img src={pwdancingdaisies} alt="PW Dancing Daisies" className="swatch-image"/>
		}else if (imageslug == 'pwdaisygarden'){
			image = <img src={pwdaisygarden} alt="PW Daisy Garden" className="swatch-image"/>
		}else if (imageslug == 'pompomparty'){
			image = <img src={pompomparty} alt="pom pom party" className="swatch-image"/>
		}else if (imageslug == 'positivityparade'){
			image = <img src={positivityparade} alt="positivity parade" className="swatch-image"/>
		}else if (imageslug == 'fuzzyfriends'){
			image = <img src={fuzzyfriends} alt="fuzzy friends" className="swatch-image"/>
		}else if (imageslug == 'dappledot'){
			image = <img src={dappledot} alt="dapple dot" className="swatch-image"/>
		}else if (imageslug == 'confetti'){
			image = <img src={confetti} alt="confetti" className="swatch-image"/>
		}else if (imageslug == 'decodot'){
			image = <img src={decodot} alt="decodot" className="swatch-image"/>
		}else if (imageslug == 'ink'){
			image = <img src={ink} alt="ink" className="swatch-image"/>
		}else if (imageslug === 'lagoon'){
			image = <img src={lagoon} alt="lagoon" className="swatch-image"/>
		}else if (imageslug == 'mist'){
			image = <img src={mist} alt="mist" className="swatch-image"/>
		}else if (imageslug == 'monstera'){
			image = <img src={monstera} alt="monstera" className="swatch-image"/>
		}else if (imageslug == 'persimmon'){
			image = <img src={persimmon} alt="persimmon" className="swatch-image"/>
		}else if (imageslug === 'fuzzymist'){
			image = <img src={fuzzymist} alt="fuzzy mist" className="swatch-image"/>
		}else if (imageslug == 'positivitybrush'){
			image = <img src={positivitybrush} alt="positivity brush" className="swatch-image"/>
		}else if (imageslug == 'seaglassleash'){
			image = <img src={seaglassleash} alt="sun terrazzo" className="swatch-image"/>
		}else if (imageslug == 'sunterrazzo'){
			image = <img src={sunterrazzo} alt="sun terrazzo" className="swatch-image"/>
		}else if (imageslug == 'wildcatsdots'){
			image = <img src={wildcatsdots} alt="wildcats dots" className="swatch-image"/>
		}else if (imageslug == 'confettipompom'){
			image = <img src={confettipompom} alt="persimmon" className="swatch-image"/>
		}else if (imageslug == 'script'){
			image = <img src={script} alt="script" className="swatch-image"/>
		}else if (imageslug == 'blushcolorblock'){
			image = <img src={blushstripe} alt="blush stripe" className="swatch-image"/>
		}else if (imageslug == 'mistcolorblock'){
			image = <img src={miststripe} alt="mist stripe" className="swatch-image"/>
		}else if (imageslug == 'seasalt'){
			image = <img src={seasalt} alt="sea salt" className="swatch-image"/>
		}else if (imageslug == 'squiggle'){
			image = <img src={squiggle} alt="squiggle" className="swatch-image"/>
		}else if (imageslug == 'wwftoucans'){
			image = <img src={wwftoucans} alt="WWF Toucans" className="swatch-image"/>
		}else if (imageslug == 'wwfhighseas'){
			image = <img src={wwfhighseas} alt="WWF High Seas" className="swatch-image"/>
		}else if (imageslug == 'wwfwildcats'){
			image = <img src={wwfwildcats} alt="WWF Wildcats" className="swatch-image"/>
		}else if (imageslug == 'wwfwildflowers'){
			image = <img src={wwfwildflowers} alt="WWF Wildflowers" className="swatch-image"/>
		}else if (imageslug == 'rndragonfruit'){
			image = <img src={rndragonfruit} alt="RN Dragonfruit" className="swatch-image"/>
		}else if (imageslug == 'rnreef'){
			image = <img src={rnreef} alt="RN Reef" className="swatch-image"/>
		}else if (imageslug == 'ojcosmos'){
			image = <img src={ojcosmos} alt="OJ Cosmos" className="swatch-image"/>
		}else if (imageslug == 'ajjfruits'){
			image = <img src={ajjfruits} alt="AJJ Fruits" className="swatch-image"/>
		}else if (imageslug == 'ajjtreats'){
			image = <img src={ajjtreats} alt="AJJ Treats" className="swatch-image"/>
		}else if (imageslug == 'aloe'){
			image = <img src={aloe} alt="Aloe" className="swatch-image"/>
		}else if (imageslug == 'amethyst'){
			image = <img src={amethyst} alt="Amethyst" className="swatch-image"/>
		}else if (imageslug == 'clay'){
			image = <img src={clay} alt="Clay" className="swatch-image"/>
		}else if (imageslug == 'lattice'){
			image = <img src={lattice} alt="Lattice" className="swatch-image"/>	
		}else if (imageslug == 'off-leash'){
			image = <img src={offleash} alt="Off Leash" className="swatch-image"/>	
		}else if (imageslug == 'sahara'){
			image = <img src={sahara} alt="Sahara" className="swatch-image"/>	
		}else if (imageslug == 'barley'){
			image = <img src={barley} alt="Barley" className="swatch-image"/>	
		}else if (imageslug == 'dove'){
			image = <img src={dove} alt="Dove" className="swatch-image"/>	
		}else if (imageslug == 'plumcolorblock'){
			image = <img src={plumstripe} alt="Plum Colorblock" className="swatch-image"/>	
		}else if (imageslug == 'plum'){
			image = <img src={plum} alt="Plum" className="swatch-image"/>	
		}else if (imageslug == 'seaglass'){
			image = <img src={seaglass} alt="Sea Glass" className="swatch-image"/>	
		}else if (imageslug == 'sunshower'){
			image = <img src={sunshower} alt="Sunshower" className="swatch-image"/>	
		}else if (imageslug == 'terrazzo'){
			image = <img src={terrazzo} alt="Terrazzo" className="swatch-image"/>	
		}else if (imageslug == 'mcmagicgarden'){
			image = <img src={mcmagicgarden} alt="MC Magic Garden" className="swatch-image"/>	
		}else if (imageslug == 'mcfoxes'){
			image = <img src={mcfoxes} alt="MC Foxes" className="swatch-image"/>	
		}else if (imageslug == 'mccranes'){
			image = <img src={mccranes} alt="MC Cranes" className="swatch-image"/>	
		}else{
			image = ''
		}

  		return(
  			<div className="swatch-image-wrapper">
  				{image}
  				<img src={soldout} className="sold-out" alt="Out of Stock"/>
  				<span className="visually-hidden">{handleOne}</span>

  			</div>
	  	);
	}


	renderDescription(product){
		let data = product

		if (Object.keys(data).length == 0 && data.constructor == Object){

		}else{
			if (data.meta.kitDescription){
				this.setState({
					description: data.meta.kitDescription
				});
			} else {
				this.setState({
					description: data.description
				});
			}
		}
	}

	renderBackgroundImage(product){

		let array = [];
		let splitImagesArray = [];
      	let result = [];
      	let obj;
      	let v;
      	let k;

		if (product.featured_image){

			if(product.meta.hasOwnProperty("kitImages") && product.meta.kitImages.length > 0 && product.meta.kitImages[0].images.length > 0){
				this.setState({
					backgroundImage: "<div class='featured-background' style='background-image: url(" + product.meta.kitImages[0].images[0].image + ")'><span></span></div>"
				});
			} else {
				this.setState({
					backgroundImage: "<div class='featured-background' style='background-image: url(" + product.featured_image + ")'><span></span></div>"
				});
			}

		}else{
			this.setState({
				backgroundImage: "<div class='featured-background'><span></span></div>"
			});
		}

		if(product.meta.hasOwnProperty("kitImages") && product.meta.kitImages.length > 0 && product.meta.kitImages[0].imageIdHook !== ""){

			var rearrange = function(input) {
	            var tmp = {}; // track keys and values as we find them
	            for (obj of input) {
	              var key = Object.keys(obj)[0]; // each input has one key
	              tmp[key] = tmp[key] || {}; // initialize an empty object at that key in tmp if necessary
	              var vals = obj[key].split(",");
	              for (v of vals) {
	                tmp[key][v.trim()] = 1; // keep each of the (trimmed) comma-delimited values, implicitly dropping duplicates
	              }
	            }

	            // now convert the tmp object into an array:
	            var output = [];
	            for (k of Object.keys(tmp)) {
	              var x = {};
	              x[k] = Object.keys(tmp[k]).join(","); // merge the values back into a comma-separated string
	              output.push(x);
	            }
	            return output;
	          }
	          const tmp = product.meta.kitImages.reduce((acc, curr) => {
	            if (acc.hasOwnProperty(curr.imageIdHook)) {
	              acc[curr.imageIdHook] = acc[curr.imageIdHook].concat(curr.images)
	              // acc[curr.variantID] = acc[curr.variantID];
	            } else {
	              acc[curr.imageIdHook] = curr.images
	              // acc[curr.variantID] = curr.variantID
	            }
	            return acc;
	          }, {})

	          result = Object.keys(tmp).map((key) => {
	            return {
	              variantID: key,
	              imageIdHook: key,
	              images: tmp[key]
	            }
	          })
	          result.forEach(function(obj) {
	            let newObj = {
	              'imageIdHook': obj.imageIdHook,
	              'images': rearrange(obj.images)
	            }
	            array.push(newObj);
	        });


	        array.forEach(function(obj) {
		   		let str = obj.images[0].image
		    	var array = str.split(',');

		    	let newObj = {
	              'imageIdHook': obj.imageIdHook,
	              'images': array
	            }
		    	splitImagesArray.push(newObj)
		    });

		    this.setState({
		    	imageVariants: splitImagesArray,
		    	galleryImages: product.meta.galleryImages,
		    	singleImage: ''
		    }, () => {
				this.setActivePrints(product.variants[0].featured_image.id);
				let allVariantImages = document.getElementsByClassName("background-variant-image");
			    if (allVariantImages.length > 0){
			    	allVariantImages[0].classList.remove('hidden');
					allVariantImages[0].classList.add('move-up');
			    	allVariantImages[0].childNodes[0].classList.remove('hidden');
			    	allVariantImages[0].childNodes[0].classList.add('move-up');
			    	let activeVariantThumbnails = document.getElementsByClassName("product-variant-thumbnails")
					activeVariantThumbnails[0].firstChild.classList.add('active');
					var thbnailcount = jQuery('.product__thumbnail:visible').length;
						jQuery('.product__thumbnail:visible .product__thumbnail-inner').each(function(i){
							jQuery(this).attr('aria-label', "image " + (i + 1) + " of " + thbnailcount)
					})
			    }
			});

		}else{
	    	this.setState({
		    	imageVariants: [],
		    	galleryImages: [],
		    	singleImage: product.images[0]
		    }, () => {
		    	let allVariantImages = document.getElementsByClassName("background-variant-image");
			    if (allVariantImages.length > 0){
			    	allVariantImages[0].classList.remove('hidden');
		    		allVariantImages[0].classList.add('move-up');
			    	allVariantImages[0].childNodes[0].classList.remove('hidden');
			    	allVariantImages[0].childNodes[0].classList.add('move-up');
					let activeVariantThumbnails = document.getElementsByClassName("product-variant-thumbnails")
					activeVariantThumbnails[0].firstChild.classList.add('active')
			    }
		    });
	    }

	}

	renderPrints(product){
		var color = product.options.includes("Color");
		let productVariants = [];
		if (product.variants.length > 1){
			product.variants.map((variant, i) =>
				{
					if(color == true){
						productVariants.push(variant);
					}else if(variant.option2 != null){
						if( variant.option2.toLowerCase() === this.state.size.toLowerCase() ){
							productVariants.push(variant);
						}
					}else{

					}
				}
			);

		}else{

		}

		this.setState({
			productVariants: productVariants

		}, () => {

		});
		
	}

	renderVideoIframe(x){
		return <ReactPlayer controls="true" url={x} title="How-to video on Diapering" className="vimeo-wrapper-overlay" width="calc(98% - 40px)" height="52vw"/>
	}

	showThisProductSpecificImage(e, x, y){

		jQuery('html, body, .product-overlay .inner').animate({scrollTop: 0}, 500);

		const current = document.querySelector('.product__thumbnail.active');
		current.className = current.className.replace("active", "");

		if(e.which == 13 || e.keyCode == 13) {
			e.target.parentElement.classList.add("active")
		}else{
			e.target.parentElement.parentElement.classList.add("active")
		}

		// Show Variant Background Images
		var allVariantBGs = document.getElementsByClassName("background-variant-image");
		for(var i = 0; i < allVariantBGs.length; i++){
		   allVariantBGs[i].classList.add("hidden")
		   allVariantBGs[i].classList.remove("move-up")
		}

		var allGalleryBGImages = document.getElementsByClassName("background-gallery-image");
		for(var i = 0; i < allGalleryBGImages.length; i++){
		   allGalleryBGImages[i].classList.add("hidden")
		   allGalleryBGImages[i].classList.remove("move-up")
		}

		var activeVariantWrapper = document.getElementById(x)
		activeVariantWrapper.classList.add("move-up")
		activeVariantWrapper.classList.remove("hidden")

		var allVariantBGImages = document.getElementsByClassName("background-product-image");
		for(var i = 0; i < allVariantBGImages.length; i++){
		   allVariantBGImages[i].classList.add("hidden")
		   allVariantBGImages[i].classList.remove("move-up")
		}
		let activeVariantBGs = document.getElementById(x).childNodes

		var elm = {};
		for (var i = 0; i < activeVariantBGs.length; i++) {
	        if (activeVariantBGs[i].id === y) {
	            elm = activeVariantBGs[i];
	            break;
	        }
	    }

		elm.classList.remove("hidden");
		elm.classList.add("move-up");
		// var thbnailcount = jQuery('.product__thumbnail:visible').length;
		// jQuery('.product__thumbnail').each(function(){
		// 	jQuery(this).removeAttr('aria-label');
		// })
		// jQuery('.product__thumbnail:visible').each(function(i){
		// 	jQuery(this).attr('aria-label', "image " + (i + 1) + " of " + thbnailcount)
		// })
	}

	showThisProductSpecificImageGallery(e, x){

		jQuery('html, body, .product-overlay .inner').animate({scrollTop: 0}, 500);
	
		const current = document.querySelector('.product__thumbnail.active');
		current.className = current.className.replace("active", "");

		if(e.which == 13 || e.keyCode == 13) {
			e.target.parentElement.classList.add("active")
		}else{
			e.target.parentElement.parentElement.classList.add("active")
		}
		var allVariantBGs = document.getElementsByClassName("background-variant-image");
		for(var i = 0; i < allVariantBGs.length; i++){
		   allVariantBGs[i].classList.add("hidden")
		   allVariantBGs[i].classList.remove("move-up")
		}

		var allGalleryBGImages = document.getElementsByClassName("background-gallery-image");
		for(var i = 0; i < allGalleryBGImages.length; i++){
		   allGalleryBGImages[i].classList.add("hidden")
		   allGalleryBGImages[i].classList.remove("move-up")
		}

		let activeGalleryBG = document.getElementById(x)

		activeGalleryBG.classList.remove("hidden");
		activeGalleryBG.classList.add("move-up");
		// var thbnailcount = jQuery('.product__thumbnail:visible').length;
		// jQuery('.product__thumbnail').each(function(){
		// 	jQuery(this).removeAttr('aria-label');
		// })
		// jQuery('.product__thumbnail:visible').each(function(i){
		// 	jQuery(this).attr('aria-label', "image " + (i + 1) + " of " + thbnailcount)
		// })
	}

	openVideoOverlay(e, videoURL){

		this.setState({
			videoOverlayURL: videoURL
		}, () => {
			this.setState({
				videoOverlay: true
			});
			var ele = document.getElementById('close-video-overlay-diapering');
			var navController = document.querySelector(".navigation");
		});
	}

	closeVideoOverlay(){
		this.setState({
			videoOverlay: false
		}, () => {
			this.setState({
				videoOverlayURL: ''
			});
			var ele = document.getElementById('close-kit-video-overlay');
			ele.focus();
		});
	}

	closeInstructionsOverlay(){
		this.setState({
			instructionsOverlay: false
		}, () => {
			this.setState({
				instructions: ''
			});
			var ele = document.getElementById('product-instructions-overlay-button');
			ele.focus();
		});
	}

	renderNewInstructions(i){
		return (
			<div className="instructions-outer">
				<div className="instructions-inner">
					{i}
				</div>
			</div>
	    );
	}

	openInstructionsOverlay(e, i){
		this.setState({
			instructions: i
		}, () => {
			this.setState({
				instructionsOverlay: true
			});
			var ele = document.getElementById('close-instructions-overlay');
			ele.focus();
		});
	}

	updateMiniCart(closed){

		let cartObjects = [];
		let close = closed
		// let newObj = {};

		var allInputValues = document.getElementsByClassName("swatch-quantity");

		for (let item of allInputValues) {
			let quant = (Number(item.value));
			let elementVariantID = item.getAttribute("data-variant");
			let price =  item.getAttribute("data-variant-price");
			let object = {
				id: elementVariantID,
				quanitity: quant,
				price: price
			}
			cartObjects.push(object)
		}

		let productID = this.state.product.id

		if (hasRun === ""){
			newObj = new obj();
			hasRun = "ran";
		}

		newObj.add('productID', productID);
		newObj.add('cartObject', cartObjects);

		this.setState({
			minicart: newObj.obj,
			totalprice: this.getTotalFromObjectPrice(newObj.obj, this.state.productQuantity, this.state.product)
		}, () => {
			if(close === "close"){
				if(this.state.productVariants.length > 0){
					this.props.closeOverlayAndSave(this.state.panel, this.state.productQuantity, this.state.minicart, this.state.product.id);
				}else{
					let productQuantity = this.state.productQuantity
					let productVariantID = this.state.product.variants[0].id
					let productPrice = this.state.product.variants[0].price
					let miniCartSingleVariant = {
						'productID': this.state.product.id,
						'cartObject': [{
							id: productVariantID,
							quanitity: productQuantity,
							price: productPrice
						}]
					}
					this.props.closeOverlayAndSave(this.state.panel, this.state.productQuantity, miniCartSingleVariant, this.state.product.id);

				}
			}

		});

	}

	updateOverlayState(product, qty, panel, babySize, cart, event, maxQ){

		let price = priceCalulator(cart, product.id)

		this.setState({
			product: product,
			price: product.variants[0].price,
			panel: panel,
			productQuantity: evaluateIfSoldOutReturnQ(product, qty),
			size: babySize,
			title: product.title,
			cart: cart,
			maxQuantity: evaluateIfSoldOutReturnQ(product, maxQ),
			imageVariants: [],
			galleryImages: []
		}, () => {
			this.renderPrints(product);
			this.setState({
				totalprice: this.printTotalsMessage(evaluateIfSoldOutReturnQ(product, qty), evaluateIfSoldOutReturnQ(product, maxQ), product, product.variants[0].price, cart),
			});
			this.renderBackgroundImage(product);
			this.renderDescription(product);
		});

	}

	closeOverlayAndSave(){
		this.updateMiniCart("close");
	}

	render(){

    	return (
	    	<div className={(this.props.detailOverlay ? 'active product-overlay' : 'product-overlay')} aria-label={"Product information on " + this.state.title} id="panel" role="dialog" aria-modal="true">

			 	<div className="inner">

			 	<button id="go-back-to-product" disabled={(this.state.readyToSave ? false : true)} className={(this.state.readyToSave ? 'close-icon' : 'inactive close-icon')} onClick={ this.ifReadyToSaveGoAheadAndSaveAndClose } onKeyPress={ e => this.ifReadyToSaveGoAheadAndSaveAndCloseAccessibility(e) } aria-label="Close"></button>

			 	<div className="overlay-thumbnails-wrapper">

			 		{ this.state.imageVariants.length > 0 &&
	 					this.state.imageVariants.map((imageContainer, i) =>
		 					<ul className='product-variant-thumbnails hidden' id={"productVariant" + String(imageContainer.imageIdHook)} key={'pv'+ i}>


		 						{
		 							imageContainer.images.map((image, i) =>
		              					<li className="product__thumbnail">
		              					 	<button className="product__thumbnail-inner" onClick={e => this.showThisProductSpecificImage(e, "productVariantBG" + String(imageContainer.imageIdHook), "productVariantBG" + i)} key={'pvd'+ i} onKeyPress={e => this.showThisProductSpecificImageAccessibility(e, "productVariantBG" + String(imageContainer.imageIdHook), "productVariantBG" + i)}>
			                  					<span style={{backgroundImage: `url(${image})`}} >
			                     					<img src={image} />
			                  					</span>
		                  					</button>
		                  				</li>
		                  			)
		 						}
      						</ul>
      					)
				 	}

			 		{ this.state.galleryImages.length > 0 &&
			 			<ul className="global-product-thumbnails">
			 				{
			 					this.state.galleryImages.map((image, i) =>
	              					<li className="product__thumbnail">
		              					<button className="product__thumbnail-inner" onClick={e => this.showThisProductSpecificImageGallery(e, "productBG" + i)} key={'productBG'+ i}  onKeyPress={e => this.showThisProductSpecificImageGalleryAccessibility(e, "productBG" + i)}>
		                  					<span style={{backgroundImage: `url(${image.image})`}}>
		                     					<img src={image.image} />
		                  					</span>
	                  					</button>
	                  				</li>
	                  			)
			 				}
			 			</ul>
				 	}

				</div>



				{ window.innerWidth > 768 &&

					<div className="desktop-images">

					 	{ this.state.imageVariants.length > 0 &&
		 					this.state.imageVariants.map((imageContainer, i) =>
				 	 			<div className='background-variant-image hidden' id={"productVariantBG" + String(imageContainer.imageIdHook)} key={'pbbgc'+ i}>
				 	 				{
			 							imageContainer.images.map((image, i) =>
				 	 						<div className="background-product-image hidden" style={{backgroundImage: `url(${image})`}} id={"productVariantBG" + i} key={'pbbg'+ i}>
				 	 							<img src={image} />
				 	 						</div>
				 	 					)
			 						}
				 	 			</div>
				 	 		)
					 	}
					 	{ this.state.galleryImages.length > 0 &&
		 					this.state.galleryImages.map((image, i) =>
	 	 						<div className="background-gallery-image hidden" style={{backgroundImage: `url(${image.image})`}} id={"productBG" + i} key={'bgi'+ i}>
	 	 							<img src={image.image} />
	 	 						</div>
				 	 		)
					 	}
					 </div>
				 }

				 { window.innerWidth < 769 &&

					<div className="mobile-images">
						{ this.state.imageVariants.length > 0 &&
		 					this.state.imageVariants.map((imageContainer, i) =>
		 						<div className='background-variant-image hidden' id={"productVariantBG" + String(imageContainer.imageIdHook)} key={'pbbgc'+ i}>
								 	<Flickity
								 	  key={'productFlickityKey'+ i}
								 	  flickityRef={c => this.flkty = c}
								      className={'carousel'} // default ''
								      elementType={'div'} // default 'div'
								      options={flickityOptions} // takes flickity options {}
								      disableImagesLoaded={false} // default false
								    >
								      {
			 							imageContainer.images.map((image, i) =>
				 	 						<div className="background-product-image hidden" style={{backgroundImage: `url(${image})`}} id={"productVariantBG" + i} key={'pbbg'+ i}>
				 	 							<img src={image} />
				 	 						</div>
				 	 					)
			 						}
			 						{ this.state.galleryImages.length > 0 &&
					 					this.state.galleryImages.map((image, i) =>
				 	 						<div className="background-gallery-image hidden" style={{backgroundImage: `url(${image.image})`}} id={"productBG" + i} key={'bgi'+ i}>
				 	 							<img src={image.image} />
				 	 						</div>
							 	 		)
								 	}
								    </Flickity>
								</div>
					 	 	)
						}
					</div>
				 }



			 	 	{ this.state.singleImage !== "" &&
			 	 		<div className="background-mobile-single" dangerouslySetInnerHTML={{__html: this.state.backgroundImage}}></div>
			 	 	}

			 		<div className="product-query-box">
			 			<div className="product-top-left">
			 				<h1 className="product-single__title">{ this.state.title }</h1>
			 			</div>
				 		<div className="product-single__price">${ formatMoney(this.state.price/100) } each</div>

			 			<div className="product-size">
			 				{ this.state.product.variants[0].options.includes(this.state.size) &&
			 					<span>Size {this.state.size} </span>
			 				}
			 				{this.state.product.meta.hasOwnProperty("kitPackNote") && this.state.product.meta.kitPackNote !== "" &&
			 					<span>{this.state.product.meta.kitPackNote}</span>
			 				}
			 			</div>


			            { this.state.description !== "" &&
							<div className="product-single-description" dangerouslySetInnerHTML={{__html: ReactHtmlParser(this.state.description)}}></div>
			        	}

			        	<div className="product--overall-quantity">
			        		<label htmlFor="productQuantityFormLabel" className="product__descriptor">Quantity:</label>
				        	<div className="product__quantity">
				        		<button className="quantity--decrement" onClick={this.decrement} onKeyPress={e => this.decrementAccessibility(e)} aria-label="decrease quantity by one">-</button>
				        		<input type="number"
				        			   aria-label="quantity"
				        			   id="productQuantityFormLabel"
                                       className="quantity"
                                       defaultValue={this.state.productQuantity}
                                       value={this.state.productQuantity}
                                       onChange={e => this.updateQuantityWhole(e)} 
                                       >
                                </input>
				        		<button className="quantity--increment" onClick={this.increment} onKeyPress={e => this.incrementAccessibility(e)} aria-label="increase quantity by one">+</button>
				        	</div>

				        	<div className="product__total">
				        		{this.state.totalprice}
				        	</div>

				        </div>
			        	{ this.state.productVariants.length > 0 &&
			        		this.state.productVariants.map((variant, ii) =>
				        		{
				        		 	return(
										<div className={"variant-swatch " + evaluateIfSoldOut(variant.inventory_quantity) + " " + this.evaluateIfActive(ii) + " " + this.getSlugHandle(variant.option1, variant.option2)} key={"swatch-" + ii} id={variant.id + "X" + ii}>
									  		<div className="product-upper" onClick={e => this.showVariantFeaturedImages(variant.featured_image.id, variant.id + "X" + ii)} onKeyPress={e => this.showVariantFeaturedImagesAccessibility(variant.featured_image.id, variant.id + "X" + ii, e)}>
										  		{
										  			this.renderSwatchImage(variant.option1, variant.option2)
										  		}
										  	</div>
									  		<div className="product-lower">
									  			<div className="product__quantity">
									  				<button className="quantity--increment" onClick={e => this.reduceQuantity("swatch-" + ii)} onKeyPress={e => this.reduceQuantityAccessibility("swatch-" + ii, e)} aria-label="decrease quantity by one">-</button>
									  				{ this.state.cart.length > 0 &&
														this.state.cart.map((product, i) =>
															<frag>
															{ this.state.product.id === product.productID &&
																product.cartObjects.length > 0 &&

																	product.cartObjects.map((vc, i) =>

                                                                        <frag>

																		{ variant.id == vc.id &&
																			<span className="product__input-text">
																				<input type="number"
																						aria-label="swatch quantity"
                                                                                       id={"swatch-" + ii}
                                                                                       data-variant={variant.id}
                                                                                       data-variant-price={variant.price}
                                                                                       className="quantity swatch-quantity"
                                                                                       defaultValue={vc.quanitity}
                                                                                       onChange={e => this.updateQuantity()}
                                                                                       onKeyPress={e => this.updateQuantityAccessibility(e)}
                                                                                       >
                                                                                </input>
																			</span>
																		}
                                                                        </frag>
																	)

															}
															{ this.state.product.id == product.productID &&
																product.cartObjects.length == 0 &&
																	<span className="product__input-text">
																		<input type="number"
																			   aria-label="swatch quantity"
                                                                               id={"swatch-" + ii}
                                                                               data-variant={variant.id}
                                                                               data-variant-price={variant.price}
                                                                               data-last-value={0}
                                                                               className="quantity swatch-quantity"
                                                                               defaultValue="0"
                                                                               onChange={e => this.evaluateVariant("swatch-" + ii, variant.inventory_quantity)}
                                                                               onKeyPress={e => this.evaluateVariantAccessibility(a, b, e)}
                                                                               >
                                                                        </input>
																	</span>
															}
															</frag>
														)
													}
									  				<button className="quantity--decrement" onClick={e => this.evaluateIfTooMany("swatch-" + ii, variant.inventory_quantity)} onKeyPress={e => this.evaluateIfTooManyAccessibility("swatch-" + ii, variant.inventory_quantity, e)} aria-label="increase quantity by one">+</button>
									  			</div>
									  		</div>
									  	</div>
									);
				        		}
							)
			        	}
			        	{ this.state.productVariants.length < 1 &&
			        		<div class="shrink-vertically"></div>
			        	}
			        	<div className="product--overall-quantity">

				        	<button disabled={(this.state.readyToSave ? false : true)} class={(this.state.readyToSave ? 'es-btn' : 'inactive es-btn')} onClick={ this.ifReadyToSaveGoAheadAndSaveAndClose } onKeyPress={e => this.ifReadyToSaveGoAheadAndSaveAndCloseAccessibility(e)} aria-label="Close">Save and Close</button>

				        	{ this.state.product.meta.hasOwnProperty("kitVideo") && this.state.product.meta.kitVideo !== "" &&
						 		<button aria-label="Open video overlay" id="close-kit-video-overlay" className="video-overlay-toggle" onClick={e => this.openVideoOverlay(e, this.state.product.meta.kitVideo)} onKeyPress={e => this.openVideoOverlayAccessibility(e, this.state.product.meta.kitVideo)}>{ this.state.title } Tutorial</button>
						 	}

						 	{ this.state.product.meta.hasOwnProperty("kitCare") && this.state.product.meta.kitCare !== "" &&
						 		<button aria-label="Open instructions overlay" id="product-instructions-overlay-button" className="instructions-toggle" onClick={e => this.openInstructionsOverlay(e, this.state.product.meta.kitCare)} onKeyPress={e => this.openInstructionsOverlayAccessibility(e, this.state.product.meta.kitCare)}>Care instructions</button>
						 	}

				        </div>

				 	</div>
		
				</div>
				<div role="dialog" aria-modal="true" aria-label="How-to video on { this.state.title }" className={(this.state.videoOverlay ? 'open active lightbox-overlay' : ' lightbox-overlay')}>
					<button aria-label="Close Video Overlay" className="js-lightbox-close lightbox-close" onClick={e => this.closeVideoOverlay()} onKeyPress={e => this.closeVideoOverlayAccessibility(e)}><div><span></span></div></button>
				    {
				    	this.renderVideoIframe(this.state.videoOverlayURL)
				    }
				</div>
				<div role="dialog" aria-modal="true" aria-label="Instructional video on { this.state.title }" className={(this.state.instructionsOverlay ? 'open active lightbox-overlay' : ' lightbox-overlay')}>
					<button aria-label="Close Instructions Overlay" id="close-instructions-overlay" className="js-lightbox-close lightbox-close" onClick={e => this.closeInstructionsOverlay()} onKeyPress={e => this.closeInstructionsOverlayAccessibility(e)}><div><span></span></div></button>
				    {
				    	this.renderNewInstructions(this.state.instructions)
				    }
				</div>
			</div>
		)
	}
};

export default ProductOverlay;
